import React, { useContext } from "react";
import {
  RULE_NAME,
  RULE_DESCRIPTION,
  RULE_STAR,
} from "../../ISRConstants";

import { SB3RuleContext } from "./SB3RuleContext";

import LogicRuleSourceConditionComponent from "../RuleComponents/LogicRuleSourceConditionComponent";
import LogicRuleTargetConditionComponent from "../RuleComponents/LogicRuleTargetConditionComponent";
import { CONSTRAINTS } from "../RuleComponents/constants";
import { mapSelectOptions } from "../../helper";
type LogicRuleComponentPropType = {
  projectId?: string | null | undefined
};


const LogicRuleComponent = ({ projectId
}: LogicRuleComponentPropType) => {
  const { showTarget, onInputChangeHandler, logicRule, updateConstraints } = useContext(SB3RuleContext);

  return (
    <div className="tw-m-2 tw-p-2 tw-pr-6  tw-w-[880px]
      tw-h-[670px] tw-overflow-scroll">
      <div>
        <div>
          <label className="cart-title tw-m-2 ">
            {RULE_NAME}
            <span className="tw-text-red-500 tw-ml-4">{RULE_STAR}</span>
          </label>
          <input data-testid="rules-logicrulecomponent-input-1"
            className="tw-h-8 tw-w-full tw-bg-shades-of-grey-10 tw-pl-0 tw-border-[1px] tw-border-solid tw-border-grey-550 tw-rounded-sm tw-ml-2"
            value={logicRule?.name}
            onChange={(e) => onInputChangeHandler(e?.target?.value, 'name')}
          />
        </div>
        <div>
          <label className="cart-title tw-m-2">{RULE_DESCRIPTION}
            {/* <span className="tw-text-red-500 tw-ml-4">{RULE_STAR}</span> */}
          </label>
          <textarea data-testid="rules-logicrulecomponent-textarea-2"
            className="tw-h-8 tw-w-full tw-bg-shades-of-grey-10 tw-pl-0 tw-border-[1px] tw-border-solid tw-border-grey-550 tw-rounded-sm tw-ml-2"
            value={logicRule?.description}
            onChange={(e) => onInputChangeHandler(e?.target?.value, 'description')}
          />
        </div>
      </div>
      <div>
        <label className="cart-title tw-m-2">Rule</label>
        <div className=" tw-bg-gray-50 tw-w-full tw-ml-2 tw-rounded-md tw-border tw-border-zinc-200">
          <LogicRuleSourceConditionComponent />
        </div>
        {showTarget &&
          <>
            <div >
              <label className=" tw-mt-2 tw-block">
                Constraints
              </label>
            <select data-testid="rules-logicrulecomponent-select-3"
              value={logicRule?.rule?.constraint}
              onChange={(e) => {
                updateConstraints(e?.target?.value)
              }}
              className="tw-w-[100px] tw-mt-2 tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-gap-2.5">
              {mapSelectOptions(CONSTRAINTS)}
              </select>
            </div>
            <div className=" tw-bg-gray-50 tw-mt-4 tw-w-full tw-ml-2 tw-rounded-md tw-border tw-border-zinc-200">
              <LogicRuleTargetConditionComponent />
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default LogicRuleComponent;
